import _classCallCheck from "/Users/neelrao/Projects/citycraft/client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/neelrao/Projects/citycraft/client/node_modules/@babel/runtime/helpers/esm/createClass";
import createCommandBuffer from '../snapshot/writer/createCommandBuffer';

var Outbound =
/*#__PURE__*/
function () {
  function Outbound(protocols, websocket, config) {
    _classCallCheck(this, Outbound);

    this.config = config;
    this.protocols = protocols;
    this.websocket = websocket;
    this.unconfirmedCommands = new Map();
    this.sendQueue = {};
    this.clientTick = 0;
    this.confirmedTick = -1;
    this.lastSentTick = -1;
  }

  _createClass(Outbound, [{
    key: "update",
    value: function update() {
      for (var i = this.lastSentTick; i < this.clientTick; i++) {
        this.sendCommands(i);
        this.lastSentTick = i;
      }

      this.clientTick++; //console.log('sq', this.sendQueue)
      //console.log('unconfirmed', this.unconfirmedCommands)
    }
  }, {
    key: "addCommand",
    value: function addCommand(command) {
      var tick = this.clientTick; //command.tick = tick

      if (typeof this.sendQueue[tick] === 'undefined') {
        this.sendQueue[tick] = [];
      }

      if (!this.unconfirmedCommands.has(tick)) {
        this.unconfirmedCommands.set(tick, []);
      }

      command[this.config.TYPE_PROPERTY_NAME] = this.protocols.getIndex(command.protocol);
      this.sendQueue[tick].push(command);
      this.unconfirmedCommands.get(tick).push(command);
    }
  }, {
    key: "sendCommands",
    value: function sendCommands(tick) {
      if (this.websocket && this.websocket.readyState === 1) {
        var commands = this.sendQueue[tick];

        if (!commands) {
          commands = [];
        }

        this.websocket.send(createCommandBuffer(tick, commands).byteArray);
        delete this.sendQueue[tick];
      }
    }
  }, {
    key: "confirmCommands",
    value: function confirmCommands(tick) {
      var _this = this;

      this.unconfirmedCommands.forEach(function (command, key) {
        if (key <= tick) {
          _this.unconfirmedCommands.delete(key);
        }
      });
      this.confirmedTick = tick;
    }
  }, {
    key: "getUnconfirmedCommands",
    value: function getUnconfirmedCommands() {
      return this.unconfirmedCommands;
    }
  }]);

  return Outbound;
}();

export default Outbound;